export const GroveMark = ({ className = "w-7 h-7 text-grove-deep" }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path
      d="M16 3L4 27h24L16 3z"
      stroke="currentColor"
      strokeWidth="2"
      className="eq-draw"
      pathLength="1"
    />
    <path
      d="M16 11l-7 14h14l-7-14z"
      fill="#2D6A4F"
      fillOpacity="0.15"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="16" cy="19" r="2" fill="currentColor" />
  </svg>
);
